import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API_URL = "https://live-evo.com/api";

function StaffUsersBannedPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBannedUsers = async () => {
    try {
      setLoading(true);

      const res = await staffFetch(`${API_URL}/staff/users-banned`);
      const data = await res.json();

      if (data.success) {
        setItems(data.data || []);
      } else {
        alert(
          data.error ||
          "Impossible de charger les utilisateurs bannis."
        );
      }
    } catch (err) {
      console.log("Erreur StaffUsersBanned:", err);
      alert("Erreur serveur.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBannedUsers();
  }, []);

  const unbanUser = async (email) => {
    const ok = window.confirm(
      `Débannir ${email} ?`
    );

    if (!ok) return;

    try {
      const res = await staffFetch(
        `${API_URL}/staff/users-banned/unban/${encodeURIComponent(email)}`,
        {
          method: "PUT"
        }
      );

      const data = await res.json();

      if (data.success) {
        setItems((prev) =>
          prev.filter(
            (item) => item.user_email !== email
          )
        );
      } else {
        alert(data.error || "Déban impossible.");
      }
    } catch (err) {
      console.log("Erreur unban:", err);
      alert("Erreur serveur.");
    }
  };

  if (loading) {
    return (
      <div style={center}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={container}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <div style={header}>
          <button
            style={backButton}
            onClick={() => {
              window.location.href = "/staff";
            }}
          >
            ← Retour
          </button>

          <div style={title}>
            Users bannis
          </div>

          <button
            style={refreshButton}
            onClick={loadBannedUsers}
          >
            Rafraîchir
          </button>
        </div>

        <div style={subtitle}>
          Liste des comptes bannis automatiquement
          ou manuellement.
        </div>

        {items.length === 0 ? (
          <div style={emptyBox}>
            <div style={emptyTitle}>
              Aucun utilisateur banni
            </div>

            <div style={emptyText}>
              Les comptes bannis apparaîtront ici.
            </div>
          </div>
        ) : (
          items.map((item) => (
            <div
              key={item.id}
              style={card}
            >
              <div style={rowBetween}>
                <div style={badge}>
                  BANNI #{item.id}
                </div>

                <div style={date}>
                  {item.created_at
                    ? new Date(
                        item.created_at
                      ).toLocaleString("fr-FR")
                    : ""}
                </div>
              </div>

              <div style={label}>
                Utilisateur
              </div>

              <div style={value}>
                {item.user_email}
              </div>

              <div style={label}>
                Motif
              </div>

              <div style={reason}>
                {item.reason || "Non précisé"}
              </div>

              <div style={label}>
                Source
              </div>

              <div style={value}>
                {item.source || "Non précisée"}
              </div>

              <div style={label}>
                Banni par
              </div>

              <div style={value}>
                {item.banned_by || "Non précisé"}
              </div>

              <button
                style={unbanButton}
                onClick={() =>
                  unbanUser(item.user_email)
                }
              >
                Débannir l’utilisateur
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "#05070d",
  color: "#fff",
  padding: 14
};

const header = {
  borderBottom:
    "1px solid rgba(0,242,255,0.18)",
  paddingBottom: 12,
  marginBottom: 14,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  flexWrap: "wrap"
};

const backButton = {
  background: "transparent",
  border: "none",
  color: "#00f2ff",
  fontWeight: "700",
  cursor: "pointer"
};

const title = {
  color: "#fff",
  fontSize: 22,
  fontWeight: "900"
};

const refreshButton = {
  background: "transparent",
  border: "1px solid #00f2ff",
  color: "#00f2ff",
  borderRadius: 10,
  padding: "8px 14px",
  fontWeight: "700",
  cursor: "pointer"
};

const subtitle = {
  color: "#8fa6ad",
  marginBottom: 20
};

const card = {
  background: "#0d111a",
  borderRadius: 16,
  border: "1px solid rgba(255,45,85,0.45)",
  padding: 14,
  marginBottom: 14
};

const rowBetween = {
  display: "flex",
  justifyContent: "space-between",
  gap: 10,
  marginBottom: 12,
  flexWrap: "wrap"
};

const badge = {
  color: "#fff",
  background: "#ff2d55",
  borderRadius: 999,
  padding: "4px 10px",
  fontSize: 12,
  fontWeight: "900"
};

const date = {
  color: "#8fa6ad",
  fontSize: 11
};

const label = {
  color: "#8fa6ad",
  fontSize: 12,
  marginTop: 8,
  marginBottom: 2,
  fontWeight: "700"
};

const value = {
  color: "#fff",
  fontSize: 13
};

const reason = {
  color: "#ffcc00",
  fontSize: 14,
  fontWeight: "800"
};

const unbanButton = {
  marginTop: 14,
  background: "#00f2ff",
  borderRadius: 12,
  padding: 12,
  border: "none",
  color: "#05070d",
  fontSize: 14,
  fontWeight: "900",
  cursor: "pointer",
  width: "100%"
};

const center = {
  minHeight: "100vh",
  background: "#05070d",
  display: "flex",
 alignItems: "center",
  justifyContent: "center",
  color: "#00f2ff"
};

const emptyBox = {
  marginTop: 80,
  textAlign: "center",
  padding: 20
};

const emptyTitle = {
  color: "#fff",
  fontSize: 18,
  fontWeight: "900",
  marginBottom: 8
};

const emptyText = {
  color: "#8fa6ad"
};

export default StaffUsersBannedPage;
